import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { CompanyService }              from '../companies/company.service';
import { MessagesService }             from '../messages/messages.service';
import { VehicleRegistrationService }  from './vehicle-registration.service';

@Component({
  selector   : 'wor-vehicle-registration-settings',
  template: require('./vehicle-registration.settings.component.html')
})
export class VehicleRegistrationSettingsComponent {
  @Input() requests: number;

  constructor (
    public  companyService     : CompanyService,
    private messagesService    : MessagesService,
    private registrationService: VehicleRegistrationService,
    private router             : UIRouter,
    private translateService   : TranslateService
  ) {}

  activate () : void {
    this.registrationService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.registrationService.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => this.messagesService.error(err));
  }

  deactivate () : void {
    this.registrationService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.registrationService.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => this.messagesService.error(err));
  }

  purchaseRequests () : void {
    this.registrationService.purchaseRequests()
    .then(() => this.router.stateService.reload());
  }
}
